




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface SocleBudget {
    hierarchyOwner: {
        brand: {
            fullName: string
        };
    };
}

@Component({ components: { SimpleText } })
export default class SubHierarchy extends Vue {
    @Prop( { default: null }) public budget!: SocleBudget;

    public static getNeededFields(): string[] {
        return [
            "budget.hierarchyOwner.brand.fullName",
        ];
    }
}
